import { GetIssueResponseDtoStatusEnum } from '@issuemanager/api-client';
import { Chip } from '@issuemanager/apps/client/components';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { useIssueStatuses } from '@issuemanager/client/features/issues';
import React from 'react';

type Props = {
  status: GetIssueResponseDtoStatusEnum;
  isInitiated?: boolean | null;
};

export function IssueStatusChip({
  status,
  isInitiated,
}: Props): React.JSX.Element | null {
  const semantic = useAtlasSemanticThemeTokens();
  const { getStatusDisplay } = useIssueStatuses();

  const statusDisplay = getStatusDisplay({
    status,
    isInitiated,
  });

  if (!statusDisplay) {
    return null;
  }

  return (
    <Chip
      data-testid='issue-status-chip'
      sx={{
        fontWeight: semantic.fontWeight.emphasis.value,
        backgroundColor: statusDisplay.backgroundColor,
        color: statusDisplay.color,
        borderRadius: 1,
        padding: semantic.spacing.default.value,
        letterSpacing: '1px',
      }}
      label={statusDisplay.label.toUpperCase()}
      title={status}
    />
  );
}
